export enum BarcodeType {
  Unknown = 0,
  Covid = 1,
  Wellness = 2
}